import * as types from "./types";

export const AdminUserInitialState = {
 

  //get request of users
  allAdminUser: [],
  allAdminUserLoading: false,
  allAdminUserError: null,
};

export const adminUserReducer = (state = AdminUserInitialState, action: any) => {
  switch (action.type) {

    case types.ALL_ADMIN_USER_FETCH_START:
      return {
        ...state,
        allAdminUserLoading: true,
      };
    case types.ALL_ADMIN_USER_FETCH_SUCCESS:
      return {
        ...state,
        allAdminUser: action.allAdminUser,
        allAdminUserLoading: false,
      };

    case types.ALL_ADMIN_USER_FETCH_FINISH:
      return {
        ...state,
        allAdminUserError: action.allAdminUserError,
        allAdminUserLoading: false,
      };

    default:
      return state;
  }
};
